var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}import React, { useEffect, useState } from 'react';
import { isObject } from 'lodash';
import { Translate } from "../../I18N";
import { Icon } from "../../UI";

import { prepareHTMLMediaView } from "../../../shared/fileUploadUtils";
import { MediaModal, MediaModalType } from "../../Metadata/components/MediaModal";
import MarkdownMedia from "../../Markdown/components/MarkdownMedia";









const getValue = (value) =>
isObject(value) && value.data ? value.data : value;

const prepareValue = (
value,
localAttachments) =>
{
  const valueString = getValue(value);
  const values = {
    originalValue: valueString,
    fileURL: valueString,
    type: ''
  };

  if (/^[a-zA-Z\d_]*$/.test(values.originalValue)) {
    values.type = 'uploadId';
  }

  if (/^https?:\/\//.test(values.originalValue)) {
    values.type = 'webUrl';
  }

  const supportingFile = localAttachments.find(
  (file) => values.originalValue === (file.url || file.fileLocalID || `/api/files/${file.filename}`));


  if (values.type === 'uploadId' && supportingFile) {
    values.fileURL = prepareHTMLMediaView(supportingFile);
  }

  return _objectSpread(_objectSpread({}, values), {}, { supportingFile });
};

const MediaField = (props) => {
  const {
    value,
    onChange,
    type,
    localAttachments = [],
    formModel,
    name: formField,
    multipleEdition
  } = props;
  const [openModal, setOpenModal] = useState(false);

  const handleCloseMediaModal = () => {
    setOpenModal(false);
  };

  const handleImageRemove = () => {
    onChange(null);
  };

  const file = prepareValue(value, localAttachments);

  useEffect(() => {
    if (file.originalValue && !file.supportingFile && file.type === 'uploadId') {
      handleImageRemove();
    }
  }, [localAttachments]);

  useEffect(
  () => () => {var _file$supportingFile;
    if ((_file$supportingFile = file.supportingFile) !== null && _file$supportingFile !== void 0 && _file$supportingFile.serializedFile && file.fileURL) {
      URL.revokeObjectURL(file.fileURL);
    }
  },
  []);


  return /*#__PURE__*/(
    _jsx("div", { className: "search__filter--selected__media" }, void 0,
    file.fileURL && (
    type === MediaModalType.Image ? /*#__PURE__*/
    _jsx("img", { src: file.fileURL, alt: "" }) : /*#__PURE__*/

    _jsx(MarkdownMedia, { config: file.fileURL })), /*#__PURE__*/


    _jsx("div", { className: "search__filter--selected__media-toolbar" }, void 0, /*#__PURE__*/
    _jsx("button", { type: "button", onClick: () => setOpenModal(true), className: "btn" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "plus" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, value ? 'Update' : 'Add file')),


    file.originalValue && /*#__PURE__*/
    _jsx("button", { type: "button", onClick: handleImageRemove, className: "btn" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "unlink" }), "\xA0 ", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Unlink"))), /*#__PURE__*/




    _jsx(MediaModal, {
      isOpen: openModal,
      onClose: handleCloseMediaModal,
      onChange: onChange,
      selectedUrl: file.originalValue,
      attachments: localAttachments,
      type: type,
      formModel: formModel,
      formField: formField,
      multipleEdition: multipleEdition })));



};

export default MediaField;